import { render, staticRenderFns } from "./means.vue?vue&type=template&id=79270150"
import script from "./means.vue?vue&type=script&lang=js"
export * from "./means.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports